import { Center } from "@mantine/core";
import { AxioLoader } from "../AxioLoader";
import { axioTokens } from "../../theme";

interface LoadingOverlayProps {
  height?: number | string;
}

export function LoadingOverlay({ height = axioTokens.unit[200] }: LoadingOverlayProps) {
  return (
    <Center h={height}>
      <AxioLoader />
    </Center>
  );
}
